export default __webpack_public_path__ + "static/media/account-details.170df349.png";